import { Component, OnInit, ViewChild, ViewEncapsulation, Inject } from '@angular/core';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { CustomMessageService } from '@app/shared/components/custom-message/custom-message.service';
import { LoggerService } from '@app/logger/logger.service';
import { FormBuilder, FormGroup, Validators, FormControl, FormArray } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { StockService } from '@app/shared/services/entities/stock.service';

import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MaterialModule } from '@app/material.module';
const log = new LoggerService('INTERVENTIONS SUITCASE PRODUCT COMPONENT')

@Component({
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
  ],
  selector: 'app-interventions-suitcase-product',
  templateUrl: './interventions-suitcase-product.component.html',
  styleUrls: ['./interventions-suitcase-product.component.scss'],
  encapsulation: ViewEncapsulation.Emulated
})
export class InterventionsSuitcaseProductComponent implements OnInit {

  mode = null;
  productOptions = [];
  filteredProductsFilter: Observable<any[]>;
  contract = null;
  kitOptions = [];
  kitItems = []
  productForm = this.formBuilder.group({
    code: [null, Validators.required],
    batch: [null, Validators.required],
    expiration: [null, Validators.required],
    quantity: [1, Validators.required],
    sellOrderId: [null, Validators.required]
  });

  

  constructor(
    private formBuilder: FormBuilder,
    private customMessageService: CustomMessageService,
    private inventoryService: StockService,
    public dialogRef: MatDialogRef<InterventionsSuitcaseProductComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) { }

  async ngOnInit() {
    this.mode = this.data.mode;
    this.contract = this.data.contract;
    this.productOptions = this.data.products;
    this.filteredProductsFilter = this.productForm.get('code').valueChanges.pipe(
      startWith(''),
      map((value: any) => (typeof value === 'string' ? value : value?.code)),
      map(name => (name ? this._filterProducts(name) : this.productOptions.slice())),
    );
    //log.debug(this.data)
  }

  /**
   * @description Display product viewValue
   * @param product 
   * @returns 
   */
  productsDisplayFn(product: any): string {
    return product && product['code'] ? product['code'] + ' - ' + product['description'] : '';
  }

  /**
   * @description Filter products
   * @param code Value to find
   * @returns Value filtered
   */
  private _filterProducts(code: string): any[] {
    if (typeof code !== 'string') return;
    const filterValue = code.toLowerCase();
    let value = this.productOptions.filter(option => String(option['code']).toLowerCase().includes(filterValue))
    return value;
  }

  async saveProduct(){
    let response = [];

    if(this.mode == 'kit') {
      let requierement = await this.checkKitRequeriments();
      if (!requierement) {
        await this.customMessageService.open({title: "Espere",type: 'error', message: `El insumo seleccionado no se puede agregar a este kit.`, dismissBtn: true });  
        return;
      }
    }

    //log.debug(this.productForm)
    if(this.productForm.valid){
      let product = this.productForm.value
      product['code'] = (product['code'] as any)['id'];
      product['type'] = 'Maleta';
      //log.debug(product)
      let n = product['quantity']
      delete product['quantity']
      //log.debug(product)
      for(let i = 1; i <= n; i++) {
        let apiResponse = await this.inventoryService.create(product)
        response.push(apiResponse.data[0])
      }
      //log.debug("pase")
      //log.debug("response",response)
      this.dialogRef.close(response);
    }
  }

  async checkKitRequeriments(){
    let requirements = this.data.requirements;
    //log.debug(requirements)
    //log.debug(this.productForm.value['code']['id'])
    return requirements.includes((this.productForm.value as any)['code']['id'])
  }
  

  

}

